import React from 'react';
import Loader from '../../common/loader';

function LoaderWrapper({ isLoading = true, children }) {
  return isLoading ? <Loader /> : children;
}

export default LoaderWrapper;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/LoaderWrapper.jsx